import React, { Component } from 'react';
// import { Container } from 'reactstrap';

class Hero extends Component {
    constructor(props) {
        super(props);
        this.state = {
            slides: [],
            currentSlide: 0,
            loading: true,
            error: null,
        };
        this.interval = null;
    }

    componentDidMount() {
        fetch(`${process.env.REACT_APP_API_URL}/api/globals/hero-slider?depth=1`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                this.setState({ slides: data.slides || [], loading: false }, () => {
                    this.interval = setInterval(this.nextSlide, 5000); // Rotate every 5s
                });
            })
            .catch((error) => {
                console.error('Hero slider fetch error:', error);
                this.setState({ error: error.message, loading: false });
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    nextSlide = () => {
        this.setState((prevState) => ({
            currentSlide: (prevState.currentSlide + 1) % prevState.slides.length,
        }));
    };

    render() {
        const { slides, currentSlide, loading, error } = this.state;

        if (loading || slides.length === 0) return null;
        if (error) return <p>Error: {error}</p>;

        const slide = slides[currentSlide];
        const backgroundUrl = slide.backgroundImage?.url || '';

        // console.log("---------------")
        // console.log(JSON.stringify(slides))
        // console.log("------------")

        const textColor = slide.foreground === 'dark' ? '#111' : '#fff';
        const textAlign = slide.alignment || 'center';

        const justifyMap = {
            left: 'flex-start',
            center: 'center',
            right: 'flex-end',
        };

        const containerStyle = {
            backgroundImage: `url(${backgroundUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '500px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: justifyMap[textAlign],
            padding: '2rem',
            color: textColor,
            transition: 'background 1s ease-in-out',
        };

        const textContainerStyle = {
            maxWidth: '800px',
            textAlign: textAlign,
            backgroundColor: slide.foreground === 'dark' ? 'rgba(255,255,255,0.75)' : 'rgba(0,0,0,0.5)',
            padding: '1.5rem',
            borderRadius: '10px',
        };

        return (

            <div style={containerStyle} className="hero-unit">

                <div style={textContainerStyle}>
                    <h1 style={{ marginBottom: '1rem' }}>{slide.title}</h1>
                    <p>{slide.description}</p>
                </div>
            </div>

        );
    }
}

export default Hero;
